<template>
  <div>
    <header-sales></header-sales>

    <div id= "subheader"> </div>
    <div id= "main-container">
      <div id= "label-container">
        <span id="label">Nuevo Pedido</span>
      </div>
      <div id= "container">
        <div id="list-header-maincontainer">
          <div id="list-header-container">
            <input id="busqueda" type="text" placeholder="Búsqueda por código o nombre del producto" v-model="txtBusqueda" v-on:keyup="onKeyDownHandler">
            <span id="nombreDeposito" @click="deleteDeposito">{{nombreDeposito}}</span>     
          </div>
          <div id= "seleccion-container" v-show="seleccion != 1">
            <span class="seleccion" @click="ckCategoria">{{nombreCategoria}}</span>
            <span class="seleccion" id="separador" v-show='nombreCategoria.length>0'>> </span>
            <span class="seleccion" @click="ckSubcategoria">{{nombreSubcategoria}}</span>
          </div>
        </div>
        <div id="list-container" v-if="show">
          <item-producto id="list-prod" v-for="item in items" :item='item' @setItem="setSelection"></item-producto>
        </div>
      </div>
      <div id="btnContainer">
          <button id="btnCarrito" @click="btnCarrito" >IR AL CARRITO</button>
      </div>
    </div>


   <!-- popup -->
   <transition name="fadePro">
   <div v-show='seleccion==4' :seleccion='seleccion'>
     <div id='back-popup'>
     </div>
     <div id='popup-realizar-pedido'>
       <div id='popup-btnClose-container'>
        <img id='btnClose' v-on:click="btnCerrarPopup" src="/dist/btnClose.png" style="width: 20px;height: 20px">
       </div>
       <p id='popup-titulo'>Ver Producto</p>
       <div id='popup-container'>
         <div id='popup-image-container'>
           <img id='popup-image' :src="imagenProducto" >
         </div>
         <div id='popup-container-text'>
           <p style=" margin-top: 36px; font-size: 12px; color: rgb(194, 126, 43); font-weight: 500;">Cod {{productoSelect.Codigo}}</p>  
           <p style="font-size: 15px; color: #5C666F; font-weight: bold;">{{nombreProducto}}</p>
           <p id='popup-descripcion-producto'>{{descripcionProducto}}</p>
           <div class="fh lc" style="margin-top: 14px; font-size: 12px; font-weight: 400; color: #5C666F;">
               <div class="fh lc" style="width: 100px">
                    Precio Lista: 
               </div>
               <div class="fh cc">
                    {{moneyLabel}} {{ precioListaComp | formatMoney}}
               </div>
           </div> 
           <div v-show="descuento > 0" class="fh lc" style="margin-top: 5px;  font-size: 12px; font-weight: 400; color: #5C666F;">
               <div class="fh lc" style="width: 100px">
                    Descuento: 
               </div>
               <div class="fh cc">
                    {{descuentoComp}} %
               </div>
           </div> 
           <div v-show="descuento <= 0" class="fh lc" style="margin-top: 5px;  font-size: 12px; font-weight: 400; color: #5C666F;">
               <div class="fh lc" style="width: 100px">
                    Descuento: 
               </div>
               <div class="fh cc">
                    -
               </div>
           </div> 
           <div class="fh lc" style="margin-top: 5px;  margin-bottom: 20px; font-size: 16px; font-weight: 500; color: #5C666F;">
               <div class="fh lc" style="width: 100px">
                    Precio:
               </div>
               <div class="fh cc">
                    {{moneyLabel}} {{ precioProductoComp | formatMoney}}                    
               </div>
           </div> 
           <div class="fh lc" style="margin-top: 5px; font-size: 12px; font-weight: 500; color: #5C666F;">
               <div class="fh lc" style="width: 100px">
                    CANTIDAD
               </div>
               <div class="fh cc">
                    <input :class='{popupCantidad:cantValida,popupCantidadInv:!cantValida}' type="text"  v-model='cantidadProducto' v-on:keyup="updateCantidad">
               </div>
           </div> 
           <div class="fh lc" v-show="showPacks" style="margin-top:2px">
               <div class="fh lc" style="width: 100px">
               </div>
               <div class="fh cc">
                    <div  :class='{popupMaximoPorcentaje:esMultiploValido,popupMaximoPorcentajeInv:!esMultiploValido}'>
                        (Debe ser múltiplo de {{UnidadesPorPedido}})
                    </div>
               </div>
           </div> 
           <div class="fh lc">
               <div class="fh lc" style="width: 100px">
               </div>
                <div class="fh cc" >
                    <div class='popupMaximoPorcentajeInv' v-show=!esMultiploValido>
                        {{valorCercano}}
                    </div>
                </div>
           </div> 
           <div class="fh lc" style="margin-top: 25px;  margin-bottom: 20px; font-size: 12px; font-weight: 500; color: #5C666F;">
               <div class="fh lc" style="width: 100px">
                    SUBTOTAL
               </div>
               <div class="fh cc" style="font-size: 14px;" >
                    {{moneyLabel}} {{subtotal | formatMoney}}
               </div>
           </div> 
         </div>
       </div>
      <div class='popup-container-inline' style="margin-top: 40px" v-show='mostrarDetalle'>
        <span id='popup-cantidad-label' style=" margin-top: 15px; margin-left: 65px">DETALLE</span>
        <textarea id="popupDetalle"  v-model='detalle'> </textarea>
      </div>
      <div id="btnContainerPopup" style="margin-top: 0px">
         <button  @click="btnCerrarPopup" id="btnCerrarPopup">CANCELAR</button>
         <button  @click="btnAgregar"     id="btnAgregarPopup">AGREGAR AL CARRITO</button>
      </div>
     </div>
   </div>
  </transition>
  <!-- popup -->

  </div>
</template>


<script>
  import axios from 'axios'
  import HeaderSales from '@components/views/header.vue';
  import ItemProducto from '@components/views/realizarPedido/itemRealizarPedido.vue';

  export default {
     name: 'RealizarPedido',
     components:{
      'header-sales': HeaderSales,
      'item-producto': ItemProducto,
     },
     data() {
       return {
        txtBusqueda:'',
        verBusqueda:false,
        seleccion:0,
        productoSelect:'',
        idCategoria:-1,
        idSubcategoria:-1,
        idProducto:-1,
        nombreCategoria:"",
        nombreSubcategoria:"",
        codigoProducto:"",
        nombreProducto:"",
        descripcionProducto:"",
        precioProducto:0.0,
        precioDeLista:0.0,
        descuento:0.0,
        descuentoPorcentaje:0.0,
        detalle:"",
        cantidadProducto: 0,
        porcentajeDescuento:0,
        tipoProducto:0,
        stockActual:0,
        peso:0.0,
        pesoMinimoPedido:0.0,
        diasEntrega:0,
        archivoId:-1,
        cantValida:true,
        porcValido:true,
        items: [],
        ImagenUrl:null,
        idCategoriasVigentes:[],
        idSubcategoriasVigentes:[],
        show:true,
        UnidadesPorPedido:1,
       }
    },


    watch: {
      $route (to, from)
        {
          if ((from.name=="realizarPedidoSubcat") && (to.name=="realizarPedidoCat")) {
            this.seleccion = 0;
            this.showItems();
          }
          if ((from.name=="realizarPedidoProd") && (to.name=="realizarPedidoSubcat")) {
            this.seleccion = 1;
            this.showItems();
        }
      }
    },


    computed: {
      moneyLabel() {
        if (this.$store.state.pedido.idMoneda == 2) {
          return 'U$S' 
        }
        else {
          return '$' 
        }
      },
      precioListaComp() {
        return this.conversionMoneda(this.precioDeLista)
      },
      descuentoComp() {
        return this.descuentoPorcentaje
      },
      precioProductoComp() {
        return (this.conversionMoneda(this.precioProducto)).toFixed(2)
      },
      categorias() {
        return this.$store.state.pedido.categorias;
      },
      subcategorias() {
        return this.$store.state.pedido.subcategorias;
      },
      productos() {
        return this.$store.state.pedido.productos;
      },
      nombreDeposito() {
        return this.$store.state.pedido.deposito.Nombre;
      },
      subtotal()  {
        var sub = this.conversionMoneda(this.cantidadProducto*this.precioProducto)
        var porc = this.porcentajeDescuento / 100
        var s = sub - (porc*sub)  
        return s.toFixed(2)
      },
      maximoDescuento() {
        return "("+this.$store.state.user.usuario.PorcentajeDescuentoMaximoPrecio +"% máximo descuento permitido)";
      },
      mostrarDescuento() {
        return this.$store.state.user.cliente.PermiteDescuentoPrecio  
      },
      mostrarDetalle() {
        if (this.tipoProducto == 2) {
          return true
        }
        else {
          return false
        }
      },
      showPacks(){
        if (this.UnidadesPorPedido > 1) {
          return true;
        } 
        else {
          return false;
        }
      },
      esMultiploValido() {
        if (this.permiteDecimales) {
          return true  
        }
        else {
          if (this.cantidadProducto % this.UnidadesPorPedido == 0) {
            return true  
          } 
          else {
            return false  
          }
        }
      },
      valorCercano() {
        var ent = Math.trunc(this.cantidadProducto/this.UnidadesPorPedido)  
        var inf = ent*this.UnidadesPorPedido  
        var sup = (ent+1)*this.UnidadesPorPedido  
        if (inf<=0) {
          return '(Valor cercano '+sup+')'  
        }
        else {
          return '(Valores cercanos '+inf+' - '+sup+')'  
        }
      },
      imagenProducto() {
        if (this.ImagenUrl != null) {
          return this.ImagenUrl
        }
        else {
          return '/dist/placeholder-producto.png'
        }
      } 
    },


    methods: {
      getProductos(idCat, idSubcat) {
        this.$store.commit('loader/start')
        var idCliente
        if (this.$store.state.user.usuario.EsEmpleado) {
          idCliente = this.$store.state.user.cliente.Id
        }
        else {
          idCliente = this.$store.state.user.usuario.ClienteId
        }
        var url = "/WebSalesProductos?DepositoId="+this.$store.state.pedido.deposito.Id+"&ClienteId="+idCliente;
        axios
            .get(url, {
              headers: {
                Token: this.$store.state.user.usuario.Token,
                ClientSecret: process.env.CLIENT_SECRET,
                EmpresaId: process.env.EMPRESA_ID
              }
            })
            .then(
              response => {
                if (response.data.Code == 0) {
                  var prods = []
                  response.data.Productos.forEach((j) => {  
                      if(j.Precio > 0)
                      {
                        prods.push(j)
                        if (!this.idCategoriasVigentes.includes(j.CategoriaId))
                        {
                            this.idCategoriasVigentes.push(j.CategoriaId)
                        }
                        if (!this.idSubcategoriasVigentes.includes(j.SubCategoriaId))
                        {
                            this.idSubcategoriasVigentes.push(j.SubCategoriaId)
                        }
                      }     
                   });  
                   this.$store.commit('pedido/saveProductos',prods);
                  this.getCategorias();
                }
                else if (response.data.Code == 99) 
                {
                  this.$store.commit("loader/stop");
                  alert(response.data.Message);
                  this.$router.push({ name: "login" });
                }
                else
                {
                  this.$store.commit("loader/stop");
                  console.log(">>>>" + response.data.Message);
                  alert(response.data.Message);
                }
              },
              error => {
                console.log(error);
                alert(error);
                this.$store.commit("loader/stop");
              }
            );
      },


      getCategorias() {
       axios.get('/WebSalesCategorias',{
          headers:{
                    Token: this.$store.state.user.usuario.Token,
                    ClientSecret: process.env.CLIENT_SECRET,
                    EmpresaId: process.env.EMPRESA_ID
                  }
        }
        ).then((response) => {
            if (response.data.Code == 0)
            {
              var catsValid = []
              response.data.Categorias.forEach((j) => {  
                if (this.idCategoriasVigentes.includes(j.Id))
                {
                  catsValid.push(j)
                }
              });  
              this.$store.commit('pedido/saveCategorias',catsValid);
              catsValid = []
              this.getSubcategorias();
            }
            else if (response.data.Code == 99)
            {
               this.$store.commit("loader/stop");
               alert(response.data.Message)
               this.$router.push({name: 'login'});
            }
            else
            {
              this.$store.commit("loader/stop");
              alert(response.data.Message);
              console.log(">>code>>"+response.data.Code);
            }
        },(error) => {
          console.log(error)
          alert(error);
          this.$store.commit("loader/stop");
          })
      },


      getSubcategorias(idCat) {
        var url = '/WebSalesSubcategorias';
        axios.get(url,{
         headers:{
                   Token: this.$store.state.user.usuario.Token,
                   ClientSecret: process.env.CLIENT_SECRET,
                   EmpresaId: process.env.EMPRESA_ID
                 }
         }
        ).then((response) => {
          this.$store.commit("loader/stop");
          if (response.data.Code == 0)
          {
            var subcatsValid = []
            response.data.Subcategorias.forEach((j) => {  
              if (this.idSubcategoriasVigentes.includes(j.Id))
              {
                subcatsValid.push(j)
              }
            });  
            this.$store.commit('pedido/saveSubcategorias',subcatsValid);
            subcatsValid = []
            this.showItems();
          }
          else if (response.data.Code == 99)
          {
            alert(response.data.Message)
            this.$router.push({name: 'login'});
          }
          else
          {
            console.log(">>>>"+response.data.Message);
            alert(response.data.Message);
          }
      },(error) => {
        console.log(error)
        alert(error);
        })
      },


      onKeyDownHandler() {
        if (this.txtBusqueda.length > 1)
        {
          this.verBusqueda = true;
          this.seleccion = 3
          var reg = new RegExp(/^\d+$/);
          if (reg.test(this.txtBusqueda))
          {
            this.items = this.productos.filter((item) =>  {return item.Codigo.toString().indexOf(this.txtBusqueda.toString()) !== -1});
          }
          else
          {
            this.items = this.productos.filter((item) =>  {return item.Nombre.toLowerCase().indexOf(this.txtBusqueda.toLowerCase()) !== -1});
          }
          var carrito = this.$store.state.pedido.carrito
          this.items.map((e) => {
            var enCarrito = false;
            carrito.forEach((j)=> {
              if (e.Id === j.id)
              {
                enCarrito = true
              }
            });
            e.showCheck = enCarrito;
            return e;
          })
        }
        if(this.txtBusqueda.length == 0)
        {
          this.verBusqueda = false;
          this.seleccion=0;
          this.showItems();
        }
        this.$store.commit('pedido/setSeleccion',this.seleccion);
      },


      showItems() {
        // 0: Los productos tienen categoria y subcategoria 
        // 1: Los productos no tienen subcategorias
        // 2: Los productos no tienen categorias
        console.log("<<<-1>>>")
        if (this.$store.state.user.usuario.ProductoCategoria == 0)  
        {
            if (this.seleccion == 0)
            {
              this.seleccion=1;
              this.$store.commit('pedido/setSeleccion',this.seleccion);
              this.items = [];
              this.items = this.categorias;
              this.items.map((e) => {
                e.showCheck = false;
                return e;
              })
            }
            else if (this.seleccion == 1)
            {
              this.seleccion=2;
              this.$store.commit('pedido/setSeleccion',this.seleccion);
              this.items = [];
              this.items = this.subcategorias.filter((item) => {return item.CategoriaId == this.idCategoria} );
              this.items.map((e) => {
                e.showCheck = false;
                return e;
              })
            }
            else if (this.seleccion == 2)
            {
              this.seleccion=3;
              this.$store.commit('pedido/setSeleccion',this.seleccion);
              this.items = [];
              this.items = this.productos.filter((item) =>  {return item.CategoriaId == this.idCategoria  && item.SubCategoriaId == this.idSubcategoria});
              var carrito = this.$store.state.pedido.carrito
              this.items.map((e) => {
                var enCarrito = false;
                carrito.forEach((j)=> {
                  if (e.Id === j.id)
                  {
                      enCarrito = true
                  }
                });
                e.showCheck = enCarrito;
                return e;
              })
            }
        }
        else if (this.$store.state.user.usuario.ProductoCategoria == 1)  
        {
            if (this.seleccion == 0)
            {
              this.seleccion=1;
              this.$store.commit('pedido/setSeleccion',this.seleccion);
              this.items = [];
              this.items = this.categorias;
              this.items.map((e) => {
                e.showCheck = false;
                return e;
              })
            }
            else if (this.seleccion == 1)
            {
              this.seleccion=3;
              this.$store.commit('pedido/setSeleccion',this.seleccion);
              this.items = [];
              this.items = this.productos.filter((item) =>  {return item.CategoriaId == this.idCategoria});
              var carrito = this.$store.state.pedido.carrito
              this.items.map((e) => {
                var enCarrito = false;
                carrito.forEach((j)=> {
                  if (e.Id === j.id)
                  {
                      enCarrito = true
                  }
                });
                e.showCheck = enCarrito;
                return e;
              })
            }
        }
        else if (this.$store.state.user.usuario.ProductoCategoria == 2)  
        {
            if (this.seleccion == 0)
            {
              this.seleccion=3;
              this.$store.commit('pedido/setSeleccion',this.seleccion);
              this.items = [];
              this.items = this.productos
              var carrito = this.$store.state.pedido.carrito
              this.items.map((e) => {
                var enCarrito = false;
                carrito.forEach((j)=> {
                  if (e.Id === j.id)
                  {
                      enCarrito = true
                  }
                });
                e.showCheck = enCarrito;
                return e;
              })
            }
        }
      },


      setSelection(id) {
        if (this.seleccion == 1)
        {
          this.$router.push({name: 'realizarPedidoSubcat'});
          this.idCategoria = id;

          var cat = this.items.find( item => item.Id === this.idCategoria);
          this.nombreCategoria = cat.Nombre;
          this.nombreSubcategoria = '';
          this.showItems();
        }
        else if (this.seleccion == 2)
        {
          this.$router.push({name: 'realizarPedidoProd'});
          this.idSubcategoria = id;
          var itemSubcategoria = this.items.find( item => item.Id === this.idSubcategoria);
          this.nombreSubcategoria = itemSubcategoria.Nombre;
          this.showItems();
        }
        else if (this.seleccion == 3)
        {
          var carrito = this.$store.state.pedido.carrito
          if (carrito.length < this.$store.state.user.usuario.CantidadMaximaLineasPedido) { 

            var enCarrito = false;
            carrito.forEach((j)=> {
                if (id === j.id)
                {
                    enCarrito = true
                }
            });

            if (!enCarrito) {
                this.idProducto = id;
                this.productoSelect = this.items.find( item => item.Id === this.idProducto);
                this.codigoProducto = this.productoSelect.Codigo;
                this.nombreProducto = this.productoSelect.Nombre;
                this.descripcionProducto = this.productoSelect.Nombre;
                this.precioProducto = this.productoSelect.Precio;
                this.precioDeLista = this.productoSelect.PrecioLista;
                this.tipoProducto = this.productoSelect.TipoProducto;
                this.descuento = this.productoSelect.Descuento;
                this.descuentoPorcentaje = this.productoSelect.DescuentoPorcentaje;
                this.stockActual = this.productoSelect.StockActual;
                this.peso = this.productoSelect.EnvasePeso;
                this.pesoMinimoPedido = this.productoSelect.PesoMinimoPedido;
                this.DiasEntrega = this.productoSelect.DiasEntrega;
                this.UnidadesPorPedido = this.productoSelect.UnidadesPorPedido;
                if ((this.pesoMinimoPedido > 0) && (this.peso > 0)) {
                    this.cantidadProducto = Math.ceil(this.pesoMinimoPedido/this.peso)
                } 
                else {
                    this.cantidadProducto = this.UnidadesPorPedido 
                }
                this.ImagenUrl = this.productoSelect.ImagenUrl;
                this.seleccion=4;
                this.porcentajeDescuento=0
            }
            else
            {
                var obj = {
                        txt:'El producto seleccionado ya se encuentra en el carrito de compras, si desea agregar más unidades puede hacerlo desde allí',
                            txtBtnCancel:'No',
                        txtBtnOk:'Ir al carrito',
                        fCancel:null,
                        fOk:this.irAlCarrito
                        }
                this.$store.commit('popup/open',obj);
            }
          }
          else {
            var obj = {
                txt: 'Ha alcanzado la cantidad máxima de ítems por pedido',
                txtBtnCancel:'',
                txtBtnOk:'Aceptar',
                fCancel:null,
                fOk:null
            }
            this.$store.commit('popup/open',obj);
          }
        }
      },

      irAlCarrito() {
        this.$router.push({name: 'pedido'});
      },

      ckCategoria() {
        this.seleccion = 0;
        this.showItems();
      },

      ckSubcategoria() {
        this.seleccion = 1;
        this.showItems();
      },

      btnCerrarPopup() {
        this.seleccion = 3;
        this.idProducto = -1;
        this.nombreProducto = "";
        this.descripcionProducto = "";
        this.precioProducto = 0.0;
        this.DiasEntrega = 0;
      },

      btnAgregar() {
        if (this.validar())
        {
          this.seleccion = 3;
          var nuevoProducto = {
            id: this.idProducto,
            idCategoria: this.idCategoria,
            idSubcategoria: this.idSubcategoria,
            producto: this.nombreProducto,
            descripcion: this.descripcionProducto,
            precio: this.precioProducto,
            precioDeLista: this.precioDeLista,
            descuento: this.descuento,
            descuentoPorcentaje: this.descuentoPorcentaje,
            precioIngresado: this.precioProducto - (this.precioProducto * (this.porcentajeDescuento / 100)),
            detalle: this.detalle,
            cantidad: this.cantidadProducto,
            peso:this.peso,
            ImagenUrl:this.ImagenUrl,
            promocionId:0,
            tipoOblea:1,
            esPromo:false,
            diasEntrega:this.DiasEntrega,
            stockActual:this.stockActual,
            manejaStock:this.productoSelect.ManejaStock,
            codigo:this.productoSelect.Codigo,
            unidadesPorPedido:this.UnidadesPorPedido,
            pesoMinimoPedido:this.pesoMinimoPedido
          };

          this.$store.commit('pedido/agregarAPedido',nuevoProducto);
          this.items.forEach((j) => {  
            if (j.Id == this.idProducto) {
              j.showCheck = true;  
            } 
          });  
          this.show = false;
          setTimeout(() => this.show = true, 50);
        }
      },


      updateCantidad() {
        var rex = new RegExp(/^\d+$/);
        if (rex.test(this.cantidadProducto)) {
          if (this.cantidadProducto < Math.ceil(this.pesoMinimoPedido/this.peso)) {
            this.cantValida = false
          }
          else {
            if (this.cantidadProducto > 0) {
                this.cantValida = true
            }
            else {
                this.cantValida = false
            }
          }
        }
        else {
          this.cantValida = false
        }
      },


      updatePorcentaje()  {
        var rex = new RegExp(/^\d+$/);
        if (rex.test(this.porcentajeDescuento)) {
          if (this.porcentajeDescuento > this.$store.state.user.usuario.PorcentajeDescuentoMaximoPrecio) {
            this.porcValido = false
          }
          else {
            this.porcValido = true
          }
        }
        else {
          this.porcValido = false
        }
      },


      validar() {
        var msg = '' 
        var valido = true
        var rex = new RegExp(/^\d+$/)
        var pesoTotalPedido = 0
        var pesoTotalActual = 0
        var importeTotalPedido = 0
        var importeTotalActual = 0
        var itemsPedido =  this.$store.state.pedido.carrito
        var limiteCtaCte = this.$store.state.user.cliente.LimiteCtaCte

        if ((rex.test(this.cantidadProducto)) && (rex.test(this.porcentajeDescuento)))
        {

            if (Number(this.cantidadProducto) < 1) {
              msg='Cantidad debe ser mayor a 0'  
              valido=false;
            }

            // calcula peso total e importe total pedido
            itemsPedido.forEach((j) => { 
              pesoTotalPedido = pesoTotalPedido  + (j.peso * j.cantidad)
              importeTotalPedido = importeTotalPedido  + (j.precio * j.cantidad)
            });  

            pesoTotalActual = pesoTotalPedido + (this.cantidadProducto * this.peso)
            importeTotalActual = importeTotalPedido + (this.cantidadProducto * this.precioProducto)

            if (Number(this.cantidadProducto) < Math.ceil(this.pesoMinimoPedido/this.peso))
            {
              msg='El peso mínimo permitido del producto es de ' + this.pesoMinimoPedido +' Kg. La cantidad mínima debería ser '+ Math.ceil(this.pesoMinimoPedido/this.peso) + ' unidades'
              valido=false;
            }

            if (Number(pesoTotalActual) > Number(this.$store.state.user.usuario.CantidadKgMaximaPedido))
            {
              msg='El peso del pedido ('+Math.ceil(pesoTotalActual)+'Kg) supera el máximo permitido ('+this.$store.state.user.usuario.CantidadKgMaximaPedido+'Kg)'
              valido=false;
            }

            if (this.productoSelect.ManejaStock)
            {
               if (Number(this.stockActual) < Number(this.cantidadProducto))
               {
                 msg='El stock actual del producto es de '+this.stockActual+' unidades'
                 valido=false;
               }               
            }

            if (this.$store.state.user.usuario.ControlaCredito)
            {
               if (Number(importeTotalActual) > Number(limiteCtaCte))
               {
                 msg='El importe actual del pedido (' +importeTotalActual  +') sobrepasa el saldo restante del límite de la Cuenta Corriente (' +limiteCtaCte +')'
                 valido=false;
               }               
            }

            if (this.porcentajeDescuento > this.$store.state.user.usuario.PorcentajeDescuentoMaximoPrecio)
            {
               msg='El porcentaje de descuento ingresado no puede ser mayor que el máximo porcentaje permitido'
               valido=false;
            }

        }

        if ((!rex.test(this.cantidadProducto)) || (!rex.test(this.porcentajeDescuento)))
        {

          if (this.$store.state.user.cliente.PermiteDescuentoPrecio)
          {
            msg='Los campos cantidad y porcentaje deben contener un valor numérico'
          }
          else
          {
            msg='El campo cantidad debe contener un valor numérico'
          }
          
          valido=false;
        }

        if (!valido) 
        {
          var obj = {
                      txt: msg,
                      txtBtnCancel:'',
                      txtBtnOk:'Aceptar',
                      fCancel:null,
                      fOk:null
                    }
          this.$store.commit('popup/open',obj);
        }

        return valido
      },


      btnAgregarPromo () {
      this.$router.push({name: 'promociones'});
      },

      btnCarrito () {
        this.$router.push({name: 'pedido'});
      },

      deleteDeposito () {
        this.$router.push({ name: "depositos" })
      },

      conversionMoneda(monto) {
        var montoConv = 0.0
        if (this.$store.state.pedido.idMoneda != this.$store.state.user.cliente.ListaPrecioMoneda) {
            if (this.$store.state.pedido.idMoneda == 2) {
                montoConv  = monto / this.$store.state.user.usuario.CotizacionDolar
            }
            else if (this.$store.state.pedido.idMoneda == 1) {
                montoConv  = monto * this.$store.state.user.usuario.CotizacionDolar
            }
        }
        else {
            montoConv  = monto 
        }
        return montoConv
      },

    },

    mounted() {
      this.$store.commit('loader/stop')
      localStorage.setItem("lastActivity",Math.floor(Date.now() / 1000));
      this.seleccion = 0;
      this.$store.commit('pedido/setSeleccion',this.seleccion);
      if ((this.categorias.length > 0) && (this.subcategorias.length > 0) && (this.productos.length > 0)) {
         this.showItems();
      }
      else {
         this.getProductos();
      }
    }

 }



</script>

<style scoped>




#back-popup{
position: absolute;
top: 0;
left: 0;
width: 100%;
height: 100vh;
background: #000000;
opacity: 0.6;
filter: alpha(opacity=60);
}



#popup-realizar-pedido{
position: absolute;
top: 50%;
left: 50%;
transform: translate(-50%,-50%);
width: 400px;
border-radius: 15px;
box-sizing: border-box;
background: #ffffff;
border-style: solid;
border-width: 1px;
border: 1px solid #dddddd;
}


#popup-btnClose-container{
  display: flex;
  flex-direction:row;
  margin-top: 10px;
  height: 20px;
  padding-right: 10px;
  align-items: center;
  justify-content: flex-end;
  background:  #ffffff
}


#popup-titulo{
 font-size: 26px;
 color: #5C666F;
 text-align: center;
}


#popup-container{
  display: flex;
  flex-direction:row;
  width: 380px;
  background:  #ffffff
}


.popupMaximoPorcentaje{
  font-size: 10px; 
  /* font-weight: 10px; */
  color: #5C666F;
}

.popupMaximoPorcentajeInv{
  font-size: 10px; 
  /* font-weight: 10; */
  color: #ff0000;
}



.popup-container-inline{
  display: flex;
  flex-direction:row;
  background:  #ffffff
}


#popup-image-container{
  width: 160px;
  height: 150px;
  margin-top:35px;
  display: flex;
  justify-content: center;
  align-items: center;

}

#popup-image{
  max-width: 90%;
  max-height: 90%;
}


/* #popup-producto{
 margin-top: 30px;
 font-size: 15px;
 color: #5C666F;
 font-weight: bold;
} */

#popup-descripcion-producto{
 margin-top: 6px;
 font-size: 11px;
 color: #5C666F;
}

#popup-precio-unitario{
 margin-top: 14px;
 margin-bottom: 20px;
 font-size: 24px;
 font-weight: 500;
 color: #5C666F;
}

#popup-cantidad-label{
 font-size: 12px;
 color: #5C666F;
 font-weight: 500;
}

#popup-subtotal-label{
 margin-top: 10px;
 font-size: 12px;
 color: #5C666F;
 font-weight: 500;
}



.popupCantidad{
 font-size: 12px;
 color: #5C666F;
 width: 60px;
 height:20px;
 margin-left: 0px;
 border-style: solid;
 border-radius: 5px;
 border:none;
 border-width: 1px;
 border: 1px solid #dddddd;
 text-align: center;
 outline: none;
}


.popupCantidadInv{
 font-size: 12px;
 color: #5C666F;
 width: 60px;
 height:20px;
 margin-left: 0px;
 border-style: solid;
 border-radius: 5px;
 border:none;
 border-width: 1px;
 border: 1px solid #ff0000;
 text-align: center;
 outline: none;
}


#popupDetalle {
  width: 245px;
  padding-left: 5px;
  margin-left: 10px;
  border-radius: 5px;
  height: 40px;
  border-style: solid;
  border: none;
  border-width: 1px;
  border: 1px solid #dddddd;
}




#popup-subtotal{
 font-size: 14px;
 margin-left: 80px;
 color: #5C666F;
}


#btnContainerPopup{
  height: 100px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}


#btnCerrarPopup{
  width: 100px;
  height: 40px;
  font-size: 10px;
  font-weight: bold;
  margin-left: 10px;
  margin-right: 10px;
  border-radius: 20px;
  border-style: solid;
  border:none;
  color: #4969B2;
  background: #ffffff;
  border-width: 1px;
  border: 1px solid #4969B2;
  outline: none;
}

#btnAgregarPopup{
  width: 160px;
  height: 40px;
  font-size: 10px;
  font-weight: bold;
  margin-left: 10px;
  margin-right: 10px;
  border-radius: 20px;
  border-style: solid;
  border:none;
  background: #44C7F4;
  color: #ffffff;
  outline: none;
}

#btnCerrarPopup:hover { cursor: pointer; }
#btnAgregarPopup:hover { cursor: pointer; }
#btnClose:hover { cursor: pointer; }



 #subheader {
 width: 100%;
 height: 35vh;
 background: linear-gradient(#005A9F , #1899D6);
 }


#main-container{
 position: absolute;
 top: 55vh;
 left: 50%;
 transform: translate(-50%,-50%);
 width: 700px;
 height: 85vh;
 }


#label-container{
  width: 700px;
  height: 10vh;
 }

#label{
  color:#ffffff;
  font-size: 27px;
 }


#container{
  width: 700px;
  height: 65vh;
  border-width: 1px;
  border: 1px solid #dddddd;
  box-sizing: border-box;
  background-color: #ffffff;
 }



#list-header-maincontainer{
    height: 13vh;
    display: flex;
    flex-direction: column;
}



#list-header-container{
    height: 9vh;
    display: flex;
    flex-direction: row;
    justify-content: center;
    background-color: #ffffff;
}



#busqueda{
 border-radius: 20px;
 width: 300px;
 margin-top:15px;
 padding-left: 40px;
 height:30px;
 border-style: solid;
 border:none;
 border-width: 1px;
 border: 1px solid #dddddd;
 color: #000000;
 outline: none;
 background: white url(/dist/icon-search.png) left no-repeat ;
 background-size: 25px 25px;
 background-position: 10px;
}


#nombreDeposito{
    border-radius: 20px;
    margin-top: 15px;
    padding-left: 10px;
    padding-right: 30px;
    margin-left: 10px;
    height: 30px;
    border-style: solid;
    border: none;
    border-width: 1px;
    color: #000000;
    outline: none;
    background: #eeeeee url(/dist/icon-close.png) right no-repeat;
    border: 1px solid #eeeeee;
    background-size: 22px 11px;
    font-size: 12px;
    display: flex;
    justify-content: center;
    align-items: center;
}




#seleccion-container{
 margin-top: 15px;
 display: flex;
 justify-content: center;
 align-items: center;
 background-color: #ffffff;
 }

.seleccion{
 color:#2292CD;
 font-weight: normal;
 margin-left:0 auto;
 margin-right: 0 auto;
 margin-top: 0px;
 font-size: 11px;
 font-weight: 500;
 text-align: center;
 }


.seleccion:hover{
    cursor: pointer;
  }

#nombreDeposito:hover{
    cursor: pointer;
  }

#separador{
 margin-left: 15px;
 margin-right: 15px;
 font-weight: 500;
 font-size: 13px;
 color:#dddddd;
 }


#list-container{
 width: 630px;
 height: 49vh;
 margin-top:0px;
 margin-left: 25px;
 margin-right: 25px;
 overflow: auto;
 background-color: #ffffff;
 }



#btnContainer{
  width: 660px;
  height: 10vh;
  display: flex;
  flex-direction:row;
  justify-content: flex-end;
  align-items: center;
 }


#btnAgregarPromo{
  width: 120px;
  height: 30px;
  font-size: 9px;
  margin-left: 5px;
  margin-right: 5px;
  border-style: solid;
  border:none;
  color: #4969B2;
  background: #ffffff;
  border-radius: 20px;
  border-width: 1px;
  border: 1px solid #4969B2;
  outline: none;
}


#btnCarrito{
  width: 100px;
  height: 30px;
  margin-left: 5px;
  margin-right: 5px;
  font-size: 9px;
  border-style: solid;
  border:none;
  background: #44C7F4;
  border-radius: 20px;
  color: #ffffff;
  outline: none;
}




.popupMaximoPorcentaje{
  font-size: 8px; 
  color: #5C666F;
}

.popupMaximoPorcentajeInv{
  font-size: 8px; 
  color: #ff0000;
}




#btnAgregarPromo:hover{cursor: pointer;}
#btnCarrito:hover{cursor: pointer;}

.fade-enter-active, .fade-leave-active {
  transition-property: opacity;
  transition-duration: .25s;
}

.fade-enter-active {
  transition-delay: .25s;
}

.fade-enter, .fade-leave-active {
  opacity: 0}





.fadePro-enter {
  opacity: 0;
}
.fadePro-enter-active {
  transition: opacity 0.5s;
}
.fadePro-enter-to {
  opacity: 1;
}
.fadePro-leave {
  opacity: 1;
}
.fadePro-leave-active {
  transition: opacity 0.1s;
}
.fadePro-leave-to {
  opacity: 0;
}

/*-----------------------------------------------------------------------------------------------------------------------*/

/* width */
::-webkit-scrollbar {
    width: 5px;
}

/* Track */
::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px #dddddd;
    border-radius: 10px;
}

/* Handle */
::-webkit-scrollbar-thumb {
    background: #cccccc;
    border-radius: 10px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
    background: #bbbbbb;
}



::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
    color: #dddddd;
    opacity: 1; /* Firefox */
}

:-ms-input-placeholder { /* Internet Explorer 10-11 */
    color: #dddddd;
}

::-ms-input-placeholder { /* Microsoft Edge */
    color: #dddddd;
}



</style>



// WEBPACK FOOTER //
// src/components/views/realizarPedido/realizarPedido.vue